import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import api from 'api/client';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const eventOptions = [
  { value: 'scan_completed', label: 'Scan Completed' },
  { value: 'scan_failed', label: 'Scan Failed' },
  { value: 'case_updated', label: 'Case Updated' },
  { value: 'case_overdue', label: 'Case Overdue' }
];

const levelOptions = [
  { value: 'info', label: 'Info' },
  { value: 'success', label: 'Success' },
  { value: 'warning', label: 'Warning' },
  { value: 'error', label: 'Error' }
];

const recipientOptions = [
  { value: 'owner', label: 'Owner' },
  { value: 'assignee', label: 'Assignee' },
  { value: 'admins', label: 'Admins' },
  { value: 'all', label: 'All Related Users' },
  { value: 'initiator', label: 'Initiator' }
];

const AdminNotificationRulesPage = () => {
  return (
    <AdminResourceCrudPage
      title="Notification Rules"
      subtitle="Define rule-based alerts for scan and case lifecycle events."
      icon={NotificationsActiveOutlinedIcon}
      endpoint="/api/admin/notification-rules/"
      columns={[
        { key: 'name', label: 'Rule' },
        { key: 'event_type', label: 'Event' },
        { key: 'level', label: 'Level' },
        { key: 'recipient_scope', label: 'Recipients' },
        { key: 'enabled', label: 'Enabled', render: (row) => (row.enabled ? 'Yes' : 'No') },
        { key: 'throttle_minutes', label: 'Throttle (min)' },
        {
          key: 'last_triggered_at',
          label: 'Last Triggered',
          render: (row) => (row.last_triggered_at ? new Date(row.last_triggered_at).toLocaleString() : '-')
        }
      ]}
      fields={[
        { name: 'name', label: 'Name', required: true },
        { name: 'event_type', label: 'Event Type', type: 'select', options: eventOptions, required: true },
        { name: 'level', label: 'Level', type: 'select', options: levelOptions, required: true },
        { name: 'recipient_scope', label: 'Recipient Scope', type: 'select', options: recipientOptions, required: true },
        { name: 'enabled', label: 'Enabled', type: 'switch', defaultValue: true },
        { name: 'send_connector', label: 'Send Connector Event', type: 'switch', defaultValue: false },
        { name: 'connector', label: 'Connector ID', nullable: true },
        { name: 'throttle_minutes', label: 'Throttle Minutes', type: 'number', defaultValue: 0 },
        { name: 'conditions', label: 'Conditions JSON', type: 'json', defaultJson: {} }
      ]}
      rowActions={[
        {
          label: 'Test Rule',
          icon: PlayArrowOutlinedIcon,
          onClick: async (row) => {
            await api.post(`/api/admin/notification-rules/${row.id}/test/`, {});
          }
        }
      ]}
    />
  );
};

export default AdminNotificationRulesPage;
